const apiKey = 'pe51xm-HCxHELUvJ5SjGI1yMRL6sIvT6CP-Adm30cmr1NEJKNXEhXs3dvuDlwnD0yh3yCQoXtIvyvLlS0YMaa_-jZX-2su__w54RDstq-WWfbItm15zwd4IUgUVBYHYx';

const Yelp = {
    search(term, location, sortBy) {
        return fetch(`https://corsanywhere.herokuapp.com/https://api.yelp.com/v3/businesses/search?term=${term}&location=${location}&sort_by=${sortBy}`, 
         {headers: {Authorization: `Bearer ${apiKey}`}})
        .then(response => {
            if (response.ok) {
                return response.json();
            } throw new Error('Request failed');
        }, networkError => {
            console.log(networkError.message);
        })
        .then(jsonResponse => {
            if (jsonResponse.businesses) {
              return  jsonResponse.businesses.map(business => {
                  return {
                      id: business.id,
                      imageSrc: business.image_url,
                      name: business.name,
                      address: business.location.address1,
                      city: business.location.city,
                      state: business.location.state,
                      zipCode: business.location.zip_code,
                      category: business.categories[0].title,
                      rating: business.rating,
                      reviewCount: business.review_count,
                      lat: business.coordinates.latitude,
                      lon: business.coordinates.longitude,
                      url: business.url
                  }
              })
            }
        })
    }
};

export default Yelp;